import React, { FC, useMemo } from 'react';
import { defaultTableName } from '../Table';
import { useTypedDispatch } from 'src/hooks/useTypedDispatch';
import { toggleSortField } from 'src/redux/slices/tableDataOperations';
import selectors from 'src/redux/selectors';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import cls from '../Table.module.scss';
import { getWidthStyles } from '../helpers';
import MainCheckboxCell from './MainCheckboxCell';
import SortIcon from 'src/assets/icons/arrows/SortIcon';
import { SortFieldTypes, TableConfig, TableDataItem } from '../types';

interface TableHeaderTitlesProps {
  config: TableConfig;
  tableData: TableDataItem[];
  actionsNumber: number;
}

const TableHeaderTitles: FC<TableHeaderTitlesProps> = ({
  config,
  tableData,
  actionsNumber,
}) => {
  const dispatch = useTypedDispatch();
  const sortFields = useTypedSelector(selectors.getSortFields);

  const sortFieldNames = useMemo(() => {
    if (config.hasSort && tableData[0]?.elements) {
      return Object.entries(tableData[0].elements).reduce(
        (accumulator, currentValue) => {
          return Object.prototype.hasOwnProperty.call(
            currentValue[1],
            'sortValue'
          )
            ? [...accumulator, currentValue[0]]
            : accumulator;
        },
        [] as string[]
      );
    }
    return [];
  }, [config.hasSort, tableData]);
  const sortField = sortFields?.[config.tableName || defaultTableName];
  return (
    <>
      <tr>
        {config.hasSelection && <MainCheckboxCell />}
        {config.th
          .filter((i) => !!i)
          .map((thConfig) => (
            <th
              key={thConfig.columnId}
              style={getWidthStyles(thConfig)}
              onClick={() => {
                if (sortFieldNames.includes(thConfig.columnId)) {
                  dispatch(
                    toggleSortField({
                      columnId: thConfig.columnId,
                      tableName: config.tableName || defaultTableName,
                    })
                  );
                }
              }}
              className={`${sortFieldNames.includes(thConfig.columnId) && 'pointer'}`}
            >
              <div className={`${cls['table__tr-title']}`}>
                {thConfig.element}
                {sortField?.columnId === thConfig.columnId &&
                  sortField?.type === SortFieldTypes.ASC && (
                    <SortIcon className="ml-10" />
                  )}
                {sortField?.columnId === thConfig.columnId &&
                  sortField?.type === SortFieldTypes.DESC && (
                    <SortIcon
                      style={{ transform: 'rotate(180deg)' }}
                      className="ml-10"
                    />
                  )}
              </div>
            </th>
          ))}
        {!!actionsNumber && (
          <th style={{ width: [0, 56, 112][actionsNumber] + 'px' }} />
        )}
      </tr>
    </>
  );
};
export default TableHeaderTitles;
